export default __webpack_public_path__ + "static/media/1031.9c98e010.svg";